import React, { useEffect, useRef, useState } from "react";

import {

    ArrowLeftIcon,

    ChevronDownIcon,

    ChevronUpIcon,

    TrashIcon,

    PencilSquareIcon,

    ChevronLeftIcon,

} from "@heroicons/react/24/outline";

import { UserPlusIcon } from "@heroicons/react/20/solid";

// Adjust path to your Catalyst Button component

import { Button } from "../../../components/catalyst/button";

import { useLocation, useNavigate } from "react-router-dom";

import ProfileFields, { ProfileForm } from "../../../components/profile/ProfileFields";

import { useSelector } from "react-redux";

import { RootState } from "../../../store";

import { doc, getDoc } from "firebase/firestore";

import { auth, db, functions } from "../../../config/firebaseConfig";

import DeleteRelatedPersonDialog from "../../../components/dialogs/DeleteRelatedPersonDialog";

import { httpsCallable } from "firebase/functions";

import { useToast } from "../../../util/ToastProvider";
import { getAuth } from "firebase/auth";
import PasswordDialog from "../../../components/dialogs/ResetPasswordFromProfileDialog";

function PersonItem({ name, formData, itemKey, onDeleteClick, userId }: { name: string, formData: any, itemKey: string, onDeleteClick: (person: { id: string; name: string }) => void; userId: string }) {

    const [open, setOpen] = useState(false);

    console.log("foem data", formData)

    const navigate = useNavigate()

    return (

        <div className="rounded-xl border border-dark-border bg-dark-background-secondary-medium px-4 py-3">

            <div className="flex items-center justify-between">

                <button

                    type="button"

                    onClick={() => setOpen((v) => !v)}

                    className="inline-flex items-center gap-2 text-left text-white font-medium"

                >

                    {open ? (

                        <ChevronUpIcon className="h-4 w-4 text-white" />

                    ) : (

                        <ChevronDownIcon className="h-4 w-4 text-white" />

                    )}

                    <span>{name} </span>

                </button>

                <div className="flex items-center gap-2">

                    <button

                        type="button"

                        className="rounded-lg p-2 text-white hover:text-rose-600 hover:bg-rose-50"

                        aria-label="Delete person"

                        onClick={() => onDeleteClick({ id: itemKey, name })}

                    >

                        <TrashIcon className="h-4 w-4" />

                    </button>

                    <button

                        type="button"

                        className="rounded-lg p-2 text-white hover:text-indigo-600 hover:bg-indigo-50"

                        aria-label="Edit person"

                        onClick={() => navigate(`/user/profile/${userId}--${itemKey}`)}

                    >

                        <PencilSquareIcon className="h-4 w-4" />

                    </button>

                </div>

            </div>

            {open && (

                <ProfileFields form={formData} />

            )}

        </div>

    );

}

export default function UserViewProfile() {

    const [formData, setFormData] = useState<ProfileForm | undefined>()

    const [relatedPerson, setRelatedPerson] = useState<any[]>([])

    const navigate = useNavigate()

    const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false)

    const [selectedPerson, setSelectedPerson] = useState<{ id: string; name: string } | null>(null);

    const toast = useToast();

    const [open, setOpen] = useState(false);

    const [googleLinked, setGoogleLinked] = useState(false);
    const [passwordEnabled, setPasswordEnabled] = useState(false);
    const [showUpdatePassword, setShowUpdatePassword] = useState(false);
    const [showSetPassword, setShowSetPassword] = useState(false);

    const uid = useSelector((s: RootState) => s.auth.user?.uid);

    const location = useLocation();

    useEffect(() => {

        if (!uid) {

            console.warn("No uid in store yet – skipping fetch.");

            return;

        }

        fetchUserDocOnce(uid);

    }, [uid, location.key]);

    useEffect(() => {
        const auth = getAuth();
        const user = auth.currentUser;

        if (user) {
            const providers = user.providerData.map(p => p.providerId);

            console.log("providerssss:", providers)
            setGoogleLinked(providers.includes("google.com"));
            setPasswordEnabled(!providers.includes("password"));
        }
    }, []);

    
    async function fetchUserDocOnce(uid: string) {

        try {

            const ref = doc(db, "users", uid);

            const snap = await getDoc(ref);

            if (snap.exists()) {

                // console.log("✅ /users doc:", { id: snap.id, ...snap.data() });

                const profileData = snap.data()

                const { form, dobDisplay } = buildProfileFormFromFS(profileData);

                setFormData(form)

                if (profileData.profile.relatedPersons) {

                    const rpMap = profileData.profile.relatedPersons;

                    const relatedPersonData = Object.keys(rpMap).map((key) => {

                        const person = rpMap[key];

                        const { form } = buildProfileFormFromFS({ profile: person });

                        return { key, form };

                    });

                    setRelatedPerson(relatedPersonData);

                }

                console.log("profile form:", form);

                console.log("dobDisplay:", dobDisplay);

            } else {

                console.log("⚠️ No /users doc for uid:", uid);

            }

        } catch (err) {

            console.error("❌ Failed to fetch /users doc:", err);

        }

    }

    function buildProfileFormFromFS(docData: any | null | undefined): {

        form: ProfileForm;

        dobDisplay: string | null;

    } {

        const p = docData?.profile ?? {};

        const birth = p?.birth ?? {};

        const curr = p?.current ?? {};

        const id = p?.identity ?? {};

        const legal = p?.legalHistory ?? {};

        const traits = p?.traits ?? {};

        const fullName =

            (id.fullName && id.fullName.trim()) ||

            [id.givenName, id.middleNames, id.familyName].filter((x) => (x ?? "").trim()).join(" ") ||

            null;

        const hadOtherLegalNames: "yes" | "no" | null =

            typeof legal.hadOtherLegalNames === "boolean"

                ? (legal.hadOtherLegalNames ? "yes" : "no")

                : null;

        const prev = Array.isArray(legal.previousNames) ? legal.previousNames : [];

        const previousNames = prev

            .map((n: any) => ({

                name: (n?.name ?? "") || null,

                from: n?.from ?? null,

                to: n?.to ?? null,

            }))

            .filter((n: any) => (n.name ?? "").trim().length > 0);

        const dobDisplay = formatDOB(birth.date ?? null, birth.time ?? null);

        let form: ProfileForm = {

            fullName,

            nicknames: id.nicknames ?? null,

            pronoun: id.pronoun ?? null,

            hadOtherLegalNames,

            previousNames,

            dominantHand: traits.dominantHand ?? null,

            placeOfBirth: birth.place ?? null,

            currentResidence: curr.residence ?? null,

            spiritualOrientation: traits.spiritualOrientation ?? null,

            relation: traits.relationship ?? null,

            birth: p.birth

        };

        if (p.id) {

            form.id = p.id

        }

        if (traits.relationship) {

            form.relation = traits.relationship

        }

        return { form, dobDisplay };

    }

    function formatDOB(date?: string | null, time?: string | null): string | null {

        if (!date && !time) return null;

        if (date && time) {

            // Treat as local time (e.g., Asia/Kolkata). If parsing fails, join raw.

            const iso = `${date}T${time}`;

            const d = new Date(iso);

            return isNaN(d.getTime())

                ? `${date}, ${time}`

                : d.toLocaleString(undefined, {

                    year: "numeric",

                    month: "long",

                    day: "numeric",

                    hour: "numeric",

                    minute: "2-digit",

                });

        }

        return date ?? time ?? null;

    }

    const handleConfirmDelete = async () => {

        if (!selectedPerson) return;

        console.log("🗑️ Deleting related person:", selectedPerson.name);

        const manageProfile = httpsCallable(functions, "manageProfile");

        try {

            console.log(selectedPerson)

            await manageProfile({

                action: "deleteRelatedPerson",

                relatedPersonId: selectedPerson.id

            });

            toast.success("Related Person Updated successfully ✅");

            navigate("/user/profile");

        } catch (error: any) {

            toast.error(error.message || "Error Updating new person ❌");

            navigate("/user/profile");

        }

        setDeleteDialogOpen(false);

        setSelectedPerson(null);

    };

    const handleDeleteClick = (person: { id: string; name: string }) => {

        setSelectedPerson(person);

        setDeleteDialogOpen(true);

    };

    return (

        <div className="min-h-screen bg-dark-background">

            <main className="mx-auto max-w-3xl lg:px-4 sm:px-0 lg:px-8 lg:py-10">

                <header className="md:hidden sticky top-0 z-40 border-b border-dark-border bg-dark-background backdrop-blur">

                    <div className="mx-auto px-4 h-16 flex items-center justify-between">

                        {/* Left: Logo */}

                        <img src="/assets/QID-logo.svg" alt="QID logo" className="h-7" />

                        {/* Right: Avatar + Dropdown */}

                        <MobileUserDropdown userName={formData?.fullName || "User"} />

                    </div>

                </header>

                {/* Card */}

                <div className="rounded-none sm:rounded-2xl px-6 py-6 bg-dark-background-secondary">

                    {/* Back + Actions */}

                    <div className="mb-4 flex items-center gap-2 text-sm text-dark-text cursor-pointer" onClick={() => navigate("/")}>

                        <ChevronLeftIcon className="h-4 w-4 " />

                        <button type="button" >Back</button>

                    </div>

                    <div className="mb-4 flex items-center justify-between">

                        <h1 className=" font-semibold text-white text-2xl">Your Account</h1>

                        <div className="hidden md:flex items-center gap-2">

                            {/* Delete account */}

                            <Button

                                outline

                                type="button"

                                className="!cursor-pointer inline-flex items-center gap-2 rounded-xl !border-dark-text-danger !bg-dark-background-secondary-medium !px-3 !py-2 text-sm font-medium !text-dark-text-danger hover:bg-slate-50"

                            >

                                Delete account

                            </Button>

                            {/* My Invoice */}

                            <Button

                                outline

                                type="button"

                                onClick={() => navigate(`/user/recipts`)}

                                className="!cursor-pointer inline-flex items-center gap-2 rounded-xl !border-dar-border-button !bg-dark-background-secondary-medium !px-3 !py-2 text-sm font-medium !text-dark-text hover:bg-slate-50"

                            >

                                Your receipts

                            </Button>

                            {/* Edit profile (primary) */}

                            {/* <Button

type="button"

color="brand"

className="cursor-pointer px-3.5 py-2 text-sm font-medium rounded-xl shadow-sm"

onClick={() => navigate(`/user/profile/${uid}`)}>

Edit profile

</Button> */}

                        </div>

                    </div>

                    <div className="flex justify-end items-center text-brand-500 text-medium px-2 cursor-pointer mt-4" onClick={() => navigate(`/user/profile/${uid}`)}>

                        <UserPlusIcon className="w-4 h-4 mx-2" />

                        <div>Edit profile</div>

                    </div>

                    <div >

                        <div className="py-2 ">

                            <dl className="rounded-2xl px-3 py-1 border border-dark-border bg-dark-background-secondary shadow-sm">

                                <ProfileFields form={formData} />

                            </dl>

                            {/* Related persons */}

                            <div className="mt-6">

                                <div className="flex items-center justify-between ">

                                    <h2 className="text-sm font-semibold text-dark-text">Related persons</h2>

                                    <div className="flex gap-2 !text-brand-500 items-center cursor-pointer " onClick={() => navigate(`/user/profile/new`)}>

                                        <UserPlusIcon className="h-4 w-4 "></UserPlusIcon>

                                        Add Related Person

                                    </div>

                                </div>

                                <div className="mt-4 bg-[#0f172a] border border-slate-700 rounded-2xl p-4 w-full ">

                                    {/* Header */}

                                    <div

                                        className="flex justify-between items-center cursor-pointer"

                                        onClick={() => setOpen(!open)}

                                    >

                                        <div>

                                            <h2 className="text-white font-medium">

                                                Manage Sign in methods

                                            </h2>

                                            <p className="text-sm text-gray-400">Email: user@gmail.com</p>

                                        </div>

                                        <ChevronDownIcon

                                            className={`h-4 w-4 text-gray-400 transition-transform ${open ? "rotate-180" : ""

                                                }`}

                                        />

                                    </div>

                                    {/* Content */}

                                    {open && (

                                        <div className="mt-4 space-y-3">

                                            {/* Email & Password */}

                                            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center bg-slate-700/40 p-4 rounded-xl gap-3">
                                                <div>

                                                    <p className="text-white font-medium">Email & password</p>

                                                    <p className="text-sm text-gray-400">

                                                        {passwordEnabled

                                                            ? "Password sign-in is enabled"

                                                            : "You can create a password login"}

                                                    </p>

                                                </div>

                                                <button
  onClick={() => {
    if (passwordEnabled) {
      setShowUpdatePassword(true);
    } else {
      setShowSetPassword(true);
    }
  }}
  className="bg-slate-600 hover:bg-slate-500 text-white px-4 py-2 rounded-lg text-sm"
>
  {passwordEnabled ? "Update password" : "Set up now"}
</button>

                                            </div>

                                            {/* Google */}

                                            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start bg-slate-900 p-4 rounded-xl border border-slate-700 gap-4">

  {/* LEFT SIDE */}
  <div className="flex gap-4 items-start">
    
    <img src="/google-icon-logo.svg" className="h-8 pt-1" />

    <div>
      <p className="text-white font-medium">Google</p>

      <p className="text-sm text-gray-400">
        You can sign in with a single click using your Google account, no password needed.
      </p>

      {!googleLinked && (
        <div className="border-t border-gray-700 mt-4 pt-4 text-gray-400">
          <div className="flex items-center gap-2 text-gray-300 text-sm font-medium mb-2">
            <div className="w-5 h-5 flex items-center justify-center rounded-full border border-gray-400 text-xs">
              i
            </div>
            <span>How to sign in with Google</span>
          </div>

          <ol className="text-sm text-gray-400 space-y-1 list-decimal pl-5">
            <li>Go to the login page.</li>
            <li>Click Continue with Google.</li>
            <li>Select your Google account.</li>
            <li>If you already have an account with the same email, you will log in to your account.</li>
            <li>After linking, you can sign in anytime using Google or email + password.</li>
          </ol>
        </div>
      )}
    </div>

  </div>

  {/* RIGHT SIDE BUTTON */}
  <button
    className={`w-full sm:w-60 py-2 text-xs rounded-lg text-sm ${
      googleLinked ? "bg-green-600 text-white" : "bg-slate-600 text-white"
    }`}
  >
    {googleLinked ? "Google OAuth is linked" : "Link Google"}
  </button>

</div>

                                        </div>

                                    )}

                                </div>

                                <div className="mt-3 space-y-3">

                                    {relatedPerson.map((data) => (

                                        <PersonItem

                                            onDeleteClick={handleDeleteClick}

                                            key={data.key}

                                            itemKey={data.key}

                                            formData={data.form}

                                            name={data.form.fullName}

                                            userId={uid || ''}

                                        />

                                    ))}

                                </div>

                            </div>

                        </div>

                        <div>

                        </div>

                    </div>

                </div>

            </main>

            <DeleteRelatedPersonDialog

                open={deleteDialogOpen}

                onClose={() => setDeleteDialogOpen(false)}

                onConfirm={handleConfirmDelete}

                personName={selectedPerson?.name || ""}

            />

            <PasswordDialog
            open={showUpdatePassword}
            onClose={() => setShowUpdatePassword(false)}
            type="Update"
            onConfirm={(password) => {
                console.log("Update password:", password);
            }}
            />

            <PasswordDialog
            open={showSetPassword}
            onClose={() => setShowSetPassword(false)}
            type="Setup"
            email={auth.currentUser?.email}
            onConfirm={(password) => {
                console.log("Set password:", password);
            }}
            />
            

        </div>
        

    );

}

function MobileUserDropdown({ userName = "" }) {

    const [open, setOpen] = useState(false);

    const navigate = useNavigate()

    const initial = userName?.trim()?.charAt(0)?.toUpperCase() || "U";

    const menuRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {

        const handler = (e: MouseEvent) => {

            if (menuRef.current && !menuRef.current.contains(e.target as Node)) {

                setOpen(false);

            }

        };

        document.addEventListener("mousedown", handler);

        return () => document.removeEventListener("mousedown", handler);

    }, []);

    return (

        <div className="relative" ref={menuRef}>

            <button onClick={() => setOpen((v) => !v)} className="flex items-center gap-2">

                <div className="w-8 h-8 rounded-full bg-brand-400 text-white flex items-center justify-center font-bold">

                    {initial}

                </div>

                <ChevronDownIcon

                    className={`w-4 h-4 text-white transition-transform ${open ? "rotate-180" : ""}`}

                />

            </button>

            {open && (

                <div className="absolute right-0 mt-2 w-40 rounded-lg bg-dark-background-secondary border border-dark-border shadow-lg py-2 z-50">

                    <button onClick={() => navigate(`/user/recipts`)} className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-dark-background-secondary-medium">

                        Your receipts

                    </button>

                    <button className="block w-full text-left px-4 py-2 text-sm text-red-400 hover:bg-dark-background-secondary-medium">

                        Delete account

                    </button>

                </div>

            )}

        </div>

        // dialogs
        

    );

}